import Authenticated from "@/Layouts/Authenticated";
import { useForm } from "@inertiajs/inertia-react";
import Label from "@/Components/Label";
import LoadingButton from "@/Components/LoadingButton";
import { Inertia } from "@inertiajs/inertia";
import PageHeading from "@/Components/PageHeading";
import React from "react";
import TextInput from "@/Components/TextInput";

const Create = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Group", route: route("groups") },
        { name: "Create", route: null },
    ];

    const { data, setData, post, errors, clearErrors, processing } = useForm({
        name: null,
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("groups.create"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("groups"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Create Group"} breadcrumb={breadcrumb} />
            <div className="mt8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"name"} label={"Group Name"} />
                                <TextInput
                                    id={"name"}
                                    name={"name"}
                                    onChange={(e) =>
                                        setData("name", e.target.value)
                                    }
                                    errors={errors.name}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className="btn-secondary"
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Save
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        // <div
        //     id="main-content"
        //     className="relative h-full w-full overflow-y-auto"
        // >
        //     <main>
        //         <div className="block flex-grow flex-col justify-between border-b-2 border-gray-200 bg-white sm:flex">
        //             <BreadCrumb
        //                 links={[
        //                     { name: "Home", route: "dashboard" },
        //                     { name: "Groups", route: "groups" },
        //                     { name: "Create", route: null },
        //                 ]}
        //             />
        //             <div className="flex space-x-6 p-2">
        //                 <h1 className="text-xl font-semibold text-gray-900 underline underline-offset-2 sm:text-2xl">
        //                     Groups
        //                 </h1>
        //             </div>
        //             <div className="space-x-2 p-2">
        //                 <Link
        //                     href={route("groups")}
        //                     className="inline-flex w-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 sm:w-auto"
        //                 >
        //                     <ChevronLeftIcon className="h-5 w-5" />
        //                     <span>Back</span>
        //                 </Link>
        //             </div>
        //         </div>
        //         <div className="flex flex-col py-4">
        //             <div className="overflow-x-auto">
        //                 <div className="inline-block flex min-w-full justify-center align-middle">
        //                     <div className="flex border border-2 p-2">
        //                         <form onSubmit={handleSubmit}>
        //                             <div>
        //                                 <Label
        //                                     label={"Group Name"}
        //                                     name={"name"}
        //                                 />
        //                                 <Input
        //                                     type={"text"}
        //                                     className={"mt-2 block"}
        //                                     errors={errors.name}
        //                                     onChange={(e) =>
        //                                         setData("name", e.target.value)
        //                                     }
        //                                     placeholder={"Test Group Name"}
        //                                     onFocus={() => clearErrors("name")}
        //                                     required={true}
        //                                 />
        //                             </div>
        //                             <div className="flex justify-end">
        //                                 <LoadingButton
        //                                     type={"submit"}
        //                                     className={"btn-primary"}
        //                                     loading={processing}
        //                                 >
        //                                     Submit
        //                                 </LoadingButton>
        //                             </div>
        //                         </form>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </main>
        // </div>
    );
};

Create.layout = (page) => (
    <Authenticated title={"Groups"}>{page}</Authenticated>
);

export default Create;
